module.exports = __webpack_public_path__ + "assets/img/asknow_logo.svg";